import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useCurrentForm } from 'hooks/risks'
import { useRowOffset, useRowsHeight } from '../../../hooks'
// components
import Rows from '../../../Rows'
// types
import { Level } from '../../utils'
import { FieldArray } from 'redux-form'
// views
import { OuterWrapper } from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableForm/components/Rows/components/Row/views'
// utils
import { isEmpty } from 'lodash'

const Wrapper = styled.div<{ $mb: number }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  transition: margin-bottom 150ms ease;
  margin-bottom: ${({ $mb }) => `${$mb}px`};
`

interface GroupProps {
  bg?: string
  level: Level
  parentId: string
  groupedBy: string
}

/** Render content for grouping tree node of fieldLink */

const FormGroup: React.FC<GroupProps> = ({ bg, level, parentId, groupedBy }) => {
  const { fieldLink } = useCurrentForm()

  const { ref } = useRowsHeight({ groupId: parentId, rowId: `${parentId}-${fieldLink.id}` })

  const offset = useRowOffset({
    rowId: `${parentId}-${fieldLink.id}`,
    groupId: parentId
  })

  return (
    <OuterWrapper $bg={bg}>
      <Wrapper ref={ref} $mb={offset}>
        {level.rows.map(([fieldValueId, nextLevel]) =>
          isEmpty(nextLevel?.rows) ? (
            <FieldArray
              bg={bg}
              component={Rows}
              key={fieldValueId}
              parentId={fieldValueId}
              name={`${fieldLink.id}[${fieldValueId}]`}
              disabled={level.fieldLinkId !== groupedBy}
            />
          ) : (
            <FormGroup key={fieldValueId} parentId={fieldValueId} level={nextLevel} groupedBy={groupedBy} bg={bg} />
          )
        )}
      </Wrapper>
    </OuterWrapper>
  )
}

export default FormGroup
